// extracted by mini-css-extract-plugin
export default {"logo":"components-Shared-Logo-themes-PP-styles__logo--ftl2K"};